import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TgadvisoryCommunityUserMappingComponent } from './tgadvisory-community-user-mapping.component';

const routes: Routes = [
  {
    path: '',
    component: TgadvisoryCommunityUserMappingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TgadvisoryCommunityUserMappingRoutingModule { }
